/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CommentCommon } from './commentCommon';
import { CommentPermissions } from './commentPermissions';
import { ListOfCommentReplies } from './listOfCommentReplies';
import { UserExtended } from './userExtended';

export interface RootComment extends CommentCommon { 
    replies_list: ListOfCommentReplies;
}